exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._17j_Hyj-r2PneG{margin-bottom:0;margin-top:8px}", ""]);

// exports
exports.locals = {
	"successMessageButton": "_17j_Hyj-r2PneG"
};